import React, { useEffect } from "react";
import styles from "./contacts.module.css";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useLocation, Link } from "react-router-dom";
import { getDataFromRoutes } from "../../utils/util_functions";
import { setMetaTags } from "../../utils/util_functions";
import { useDispatch } from "react-redux";
import { ROUTES_CONST, COMPANY_SELLER, PHONE_NUMBERS, EMAILS } from "../../utils/constants";



const Contacts = () => {

  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle);
    // eslint-disable-next-line
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);



  return (
    <main className="main">
      <h1 className="title">{title}</h1>
      <div className={styles.container}>

        <section>
          <div>
            <ul className={styles.list}>
              <li>
                <p className="text"><span style={{ 'fontWeight': 500 }}>
                  Адрес:</span> {COMPANY_SELLER.adress}
                </p></li>
              <li>
                <p className="text"><span style={{ 'fontWeight': 500 }}>
                  Режим работы:</span> {COMPANY_SELLER.working_hours}
                </p>
              </li>
            </ul>

            <ul className={styles.list}>
              {
                PHONE_NUMBERS.map((phone, index) => {
                  return (
                    <li key={index}>
                      {phone.name ?
                        <Link to={phone.link} className={styles.link}>
                          <span style={{ 'fontWeight': 500 }}>{phone.name}</span>: {phone.number}
                        </Link>
                        :
                        <Link to={phone.link} className={styles.link}>
                          {phone.number}
                        </Link>
                      }
                    </li>
                  )
                })
              }
            </ul>

            <ul className={styles.list}>
              {
                EMAILS.map((email, index) => {
                  return (
                    <li key={index}>
                      {email.name ?
                        <Link to={`mailto:${email.email}`} className={styles.link}>
                          <span style={{ 'fontWeight': 500 }}>{email.name}:</span> {email.email}
                        </Link> :
                        <Link to={`mailto:${email.email}`} className={styles.link}>
                          {email.email}
                        </Link>
                      }
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </section>

        <section>
          <h3 className="subtitle subtitle__left">Где нас найти</h3>
          <iframe
            title="map"
            className={styles.map}
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A1d701a8451c671ef5ae0c6385f2c4f266550cff22864e0d5645fbd4b1216a198&amp;source=constructor"
            width="600" height="500" frameborder="0"></iframe>
        </section>
        <section>
          <h3 className="subtitle subtitle__left">Реквизиты</h3>
          <ul className={`${styles.list} ${styles.list__noUpper}`}>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                Полное наименование:</span> {COMPANY_SELLER.name}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                Краткое наименование:</span> {COMPANY_SELLER.short_name}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                Юридический адрес:</span> {COMPANY_SELLER.adress}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                ИНН:</span> {COMPANY_SELLER.inn}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                КПП:</span> {COMPANY_SELLER.kpp}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                ОГРН:</span> {COMPANY_SELLER.ogrn}
              </p>
            </li>

            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                Банк:</span> {COMPANY_SELLER.bank_name}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                БИК:</span> {COMPANY_SELLER.bik}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                Корр. счет:</span> {COMPANY_SELLER.korr_schet}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                Расс. счет:</span> {COMPANY_SELLER.rass_schet}
              </p>
            </li>
            <li>
              <p className="text"><span style={{ 'fontWeight': 500 }}>
                {COMPANY_SELLER.director_post}:</span> {COMPANY_SELLER.director_name}
              </p>
            </li>
          </ul>
        </section>
      </div>
    </main>
  );
}

export default Contacts;
